import React, { useEffect, useState } from 'react';
import { UserProfileContext } from '../contexts/UserProfile';
import { getProfile, UserProfile } from '../services/profile';

export const UserProfileProvider: React.FC<{ children?: JSX.Element }> = (
  props,
) => {
  const [profile, setProfile] = useState<UserProfile | null>(null);

  useEffect(() => {
    (async () => {
      setProfile(await getProfile());
    })();
  }, []);

  return (
    <UserProfileContext.Provider value={[profile, setProfile]}>
      {props.children}
    </UserProfileContext.Provider>
  );
};
